import { render, staticRenderFns } from "./ValueDeleteDialog.vue?vue&type=template&id=0296d60f&scoped=true"
import script from "./ValueDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ValueDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0296d60f",
  null
  
)

export default component.exports